var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-bar-li",class:_vm.isCurrent ? 'is-current' : '',on:{"click":function($event){$event.stopPropagation();return _vm._clickPush($event)}}},[_vm._v(" "+_vm._s(_vm.model.meta ? _vm.model.meta.title : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }